import React from "react";
import { Menu } from "@headlessui/react";

import { delay } from "utils";
import TableActionMenuWrapper from "./TableActionMenuWrapper";
import ConfirmDialog from "./ConfirmDialog";
import { useDispatch } from "react-redux";
import { closeModal, openModal } from "state/slices/modals";
import { PencilIcon, RefreshIcon, TrashIcon } from "@heroicons/react/outline";

const OrganizationsTableActionMenu = ({
  row,
  disableResendInviteBtn,
  disableReviewBtn,
  disableResetAccessBtn,
  disableRemoveBtn,
  hideResendInviteBtn,
  hideReviewBtn,
  showViewBtn,
  handleResendInvite,
  handleRemove,
  deleteConfirmationLabel = "Are you sure you want to delete this organization?",
}) => {
  const dispatch = useDispatch();

  const handleViewRow = async (row) => {
    if (!row.isExpanded) {
      row.toggleAllRowsExpanded(false); // Close all rows
      await delay(10);
      row.toggleRowExpanded(); // Open the clicked row
    } else {
      row.toggleRowExpanded();
    }
  };

  return (
    <div>
      <TableActionMenuWrapper>
        {!hideResendInviteBtn && (
          <Menu.Item>
            {({ active }) => (
              <button
                type="button"
                disabled={disableResendInviteBtn}
                onClick={() => handleResendInvite(row.original)}
                className={`${
                  active && !disableResendInviteBtn
                    ? "bg-violet-500 text-white"
                    : "text-gray-900"
                } group flex rounded-md items-center w-full px-2 py-1 text-sm disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-500`}
              >
                Resend invite
              </button>
            )}
          </Menu.Item>
        )}
        {!hideReviewBtn && (
          <Menu.Item>
            {({ active }) => (
              <button
                type="button"
                disabled={disableReviewBtn}
                {...(!disableReviewBtn ? row?.getToggleRowExpandedProps() : {})}
                className={`${
                  active && !disableReviewBtn
                    ? "bg-violet-500 text-white"
                    : "text-gray-900"
                } group flex rounded-md items-center w-full px-2 py-1 text-sm disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-500`}
              >
                <PencilIcon className="w-5 h-5 mr-1" aria-hidden="true" />
                {row.isExpanded ? "Close" : "Review"}
              </button>
            )}
          </Menu.Item>
        )}
        {showViewBtn && (
          <Menu.Item>
            {({ active }) => (
              <button
                type="button"
                onClick={() => handleViewRow(row)}
                className={`${
                  active ? "bg-violet-500 text-white" : "text-gray-900"
                } group flex rounded-md items-center w-full px-2 py-1 text-sm disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-500`}
              >
                {row.isExpanded ? "Close" : "View"}
              </button>
            )}
          </Menu.Item>
        )}
        {
          <Menu.Item>
            {({ active }) => (
              <button
                type="button"
                disabled={disableResetAccessBtn}
                className={`${
                  active && !disableResetAccessBtn
                    ? "bg-violet-500 text-white"
                    : "text-gray-900"
                } group flex rounded-md items-center w-full px-2 py-1 text-sm disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-500`}
              >
                <RefreshIcon className="w-5 h-5 mr-1" aria-hidden="true" />
                Reset Access
              </button>
            )}
          </Menu.Item>
        }
        {
          <Menu.Item>
            {({ active }) => (
              <button
                type="button"
                onClick={() =>
                  dispatch(
                    openModal({
                      modalName: "delete_confirmation_modal",
                    })
                  )
                }
                disabled={disableRemoveBtn}
                className={`${
                  active && !disableRemoveBtn
                    ? "bg-red-600 text-white"
                    : "text-gray-900"
                } group flex rounded-md items-center w-full px-2 py-1 text-sm disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-500`}
              >
                <TrashIcon className="w-5 h-5 mr-1" aria-hidden="true" /> Delete
              </button>
            )}
          </Menu.Item>
        }
      </TableActionMenuWrapper>

      <ConfirmDialog
        name="delete_confirmation_modal"
        onClose={() => dispatch(closeModal("delete_confirmation_modal"))}
        onConfirm={() => handleRemove(row)}
      >
        {deleteConfirmationLabel}
      </ConfirmDialog>
    </div>
  );
};

export default OrganizationsTableActionMenu;
